import { combineReducers } from "redux";
import ApplicationReducer from "./application/reducer";
import WidgetReducer from "./tiktok-widget/reducer";
import ButtonWidgetReducer from "./button-widget/reducer";
import ShopReducer from "./shops/reducer";

const rootStateProvider = {
  AppReducer: ApplicationReducer,
  TiktokWidgetReducer: WidgetReducer,
  ButtonWidgetReducer: ButtonWidgetReducer,
  ShopReducer: ShopReducer
};

const reducer = combineReducers(rootStateProvider);
export type RootReducer = ReturnType<typeof reducer>;
export default reducer;
